const initialState = {
	"paso": 0,
	"correo": "",
	"contrasena": "",
	"intento": 0,
	"secreto": "",
	"cveCliente": "",
	"pUno": "",
	"pUnoText": "",
	"pDos": "",
	"pDosText": "",
	"accesoFamiliar": false,
	"uid": "",
	"error": false,
	"errorMsj": ""
};

export function loginRdc(state = initialState, action) {
	
	switch (action.type) {
	case "LOGIN_PASO_SIGUIENTE": 
		return {...state,
			"paso": state.paso + 1
		};
	case "LOGIN_PASO_ANTERIOR":
		return {...state,
			"paso": state.paso - 1
		};
	case "LOGIN_RESET_PASO":
		return {...state,
			"paso": 0
		};
	case "LOGIN_SET_CORREO":
		return {...state,
			"correo": action.correo
		};
	case "LOGIN_SET_CONTRASENA":
		return {...state,
			"contrasena": action.contrasena
		};
	 case "LOGIN_SET_PASO":
		return {...state,
			"paso": action.paso
		};
	case "LOGIN_SET_SECRETO":
		return {...state,
			"secreto": action.secreto
		};
	case "LOGIN_SET_CVECLIENTE": 
		return {...state,
			"cveCliente": action.cveCliente
		};
	case "LOGIN_INCREMENTA_INTENTO":
		return {...state,
			"intento": state.intento + 1
		};
	case "LOGIN_RESET_INTENTO":
		return {...state,
			"intento": 0
		};
	case "LOGIN_SET_PREGUNTA_UNO":
		return {...state,
			"pUno": action.id,
			"pUnoText": action.texto
		};
	case "LOGIN_SET_PREGUNTA_DOS":
		return {...state,
			"pDos": action.id,
			"pDosText": action.texto
		};
	case "LOGIN_SET_ACCESO_FAMILIAR":
		return {...state,
			"accesoFamiliar": action.accesoFamiliar
		};
	case "LOGIN_SET_PREGUNTAS":
		return {...state,
			"pUno": action.p1,
			"pDos": action.p2
		};
	case "LOGIN_SET_UID":
		return {...state,
			"uid": action.uid
		};
	case "LOGIN_SET_ERROR":
		return {...state,
			"error": action.error,
			"errorMsj": action.mensaje
		};
	case "LOGIN_SET_EVENT":
		return {...state,
			"evento": action.evento
		};
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/gnp-login/reducer.js